import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Box, Link } from '@material-ui/core';
import { useBenefitsTitleStyles } from './styles';

const BenefitsTitle = ({ ...props }) => {
  const { image, mobile, type, onClick, points } = props;
  const classes = useBenefitsTitleStyles();

  return (
    <Box
      className={
        mobile
          ? `${classes.boxMobile} ${classes.container}`
          : `${classes.boxDesktop} ${classes.container}`
      }
    >
      {type !== 'silver' && type !== 'gold' && (
        <Typography variant="h3">
          Sigue acumulando puntos para tener estos
        </Typography>
      )}
      <Box display="flex" alignItems="center">
        <Typography className={classes.client}>
          &nbsp;Beneficios cliente
        </Typography>
        <img src={image} />
      </Box>
      {type === 'silver' && (
        <Typography variant="h3">
          con {20000 - Number(points)} puntos más podrás ser{' '}
          <Link data-cy="linkBenefitsGold" onClick={() => onClick()}>
            Gold
          </Link>
        </Typography>
      )}
    </Box>
  );
};

BenefitsTitle.propTypes = {
  image: PropTypes.string,
  mobile: PropTypes.bool,
  type: PropTypes.string,
  onClick: PropTypes.func,
  points: PropTypes.number,
};

export default BenefitsTitle;
